import * as types from "./mutation-types";

/**
 * Export all mutations
 */
export default {
  /**
   * @param state
   * @param payload
   */
  [types.SET_USER](state, payload) {
    state.user = Object.assign({}, payload);
  },
  /**
   * @param state
   * @param payload
   */
  [types.SET_TOKEN](state, payload) {
    state.token = payload;
  },

  [types.SET_PARTNER_TERMS](state, payload) {
    console.log('PartnerTerms', payload)
    state.partner_terms = payload;
  },

  /**
   * @param state
   * @param payload
   */
  [types.SET_SIGN_UP_SKELETON](state, payload) {
    state.sign_up_skeleton = payload;
  },

  /**
   * @param state
   * @param payload
   */
  [types.SET_SIGN_UP_FLIP_PARTNER_TYPE](state, payload) {
    state.partner_type_flip_signup = payload;
  },

  [types.SET_EXTERNAL_SIGNUP_PAGE](state, payload) {
    state.external_sign_up_page = payload;
  },

  [types.SET_GENDERS](state, payload) {
    state.genders = payload;
  },

  [types.SET_PLATFORM_ACCESS_RECORDS](state, payload) {
    if ( !payload || Object.keys(payload).length === 0 ) return;

    console.log('SET_PLATFORM_ACCESS_RECORDS', payload )

    Object.entries(payload).forEach(([key, value]) => {
      state.platform_access_records[key] = value;
    });
  },
};
